import { render, staticRenderFns } from "./AboutUsSection.vue?vue&type=template&id=0c6118b1&scoped=true"
import script from "./AboutUsSection.vue?vue&type=script&lang=js"
export * from "./AboutUsSection.vue?vue&type=script&lang=js"
import style0 from "./AboutUsSection.vue?vue&type=style&index=0&id=0c6118b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6118b1",
  null
  
)

export default component.exports